export default {"src":"/_next/static/media/Frame.fbf1dfff.svg","height":464,"width":578,"blurWidth":0,"blurHeight":0};